export default "__VITE_ASSET__d5adeb89__"